<template>
  <div class="tutorial-message">
    <strong>{{message.title}}</strong>
    <p>{{message.body}}</p>

    <img :src="imagePath" class="image" v-on:error="replaceDefaultImage">

    <div class="actions">
      <span v-on:click="close" class="close">OK</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tutorial',
  props: {
    message: {
      uid: String,
      title: String,
      body: String,
    },
  },
  data() {
    return {
      imagePath: `/static/img/${this.message.uid}.png`,
    };
  },
  created() {
    this.$store.dispatch('stopGame');
  },
  destroyed() {
    this.$store.dispatch('restartGame');
  },
  methods: {
    close() {
      this.$store.dispatch('readTutorial', this.message.uid);
    },
    replaceDefaultImage() {
      this.imagePath = '/static/img/default.png';
    },
  },
  computed: {
    isOpened() {
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.tutorial-message {
  p {
    line-height: 1.6em;
    text-align: left;
  }

  .actions {
    text-align: center;
  }

  .image {
    max-width: 500px;
    margin: 1rem 0;
  }

  .close {
    display: inline-block;
    width: 300px;
    margin: 1rem;
    padding: 1rem;
    border-radius: 3px;
    background: #0a5;
    color: #fff;
    font-weight: bold;
    font-size: 0.9rem;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/TutorialMessage.vue